import React from "react";
import { Link } from "gatsby";
import ServiceSalesSequences from "../../images/sales-sequences.png";
import ServiceWorkflowAutomation from "../../images/workflow-automation.png";
import ServiceBulkCampaigns from "../../images/bulk-campaigns.png";
import IconSalesSequences from "../../icons/icon-sales.svg";
import IconWorkflowAutomation from "../../icons/icon-workflow.svg";
import IconBulkCampaigns from "../../icons/icon-bulk-campaigns.svg";



export const serviceTabObj = {
  title: "Automating the sales playbook",
  tabItems: [
    {
      header: "Sales Sequences",
      content: "Build reusable and automated sales cadences & follow-ups",
      icon: <IconSalesSequences />
    }, {
      header: "Workflow Automation",
      content: "Create custom automation to update data, assign tasks, send reminders",
      icon: <IconWorkflowAutomation />
    }, {
      header: "Bulk Campaigns",
      content: "Reach hundreds of prospects with single-click personalized campaigns",
      icon: <IconBulkCampaigns />
    },
  ],
  serviceMediaOne: [
    {
      source: ServiceSalesSequences,
      class: "banner-img-sales"
    },
  ],
  serviceMediaTwo: [
    {
      source: ServiceWorkflowAutomation,
      class: "service-banner-automation"
    },
  ],
  serviceMediaThree: [
    {
      source: ServiceBulkCampaigns,
      class: "service-banner-bulk"
    },
  ]
};

